import { callApi } from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import * as Types from 'apps/fleet-planner/types'

export const fetchCurrentUser = (): Promise<Types.IGetCurrentUserResponse> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.current_user,
  }
  return callApi(requestData)
}

export const fetchCurrentUserMotorCarriers = (): Promise<
  Types.IGetCurrentUsersMotorCarriersResponse
> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.motor_carriers,
  }
  return callApi(requestData)
}

export const fetchMotorCarriersSearch = (
  params: Partial<Types.IFetchMotorCarrierSearchParams>
): Promise<Types.ISearchMotorCarriersResponse> => {
  const requestData = {
    method: 'GET',
    endpoint: FP_ENDPOINTS.motor_carriers_search,
    params,
  }
  return callApi(requestData)
}

export const updateUserOnboarding = (
  payload: Types.IUpdateUserOnboardingRequest
): Promise<Types.IUpdateUserOnboardingResponse> => {
  const requestData = {
    method: 'PUT',
    endpoint: FP_ENDPOINTS.current_user,
    group: 'onboarding',
    body: payload,
  }
  return callApi(requestData)
}
